module.exports = __webpack_public_path__ + "static/media/galerija_2023 (6).ae4a6d34.jpg";